import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { SET_TRANSFERRED_FOR_TRANSPORT, SET_PICKUP_DATE } from '../../redux/OffersDetails';
import icons from '../../helpers/Icons';
import PickupDateBar from './PickupDateBar';
import { compose } from 'redux'
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';
class PickupDateBarContainerEasyTransport extends PureComponent {
  state = {
    isSendFormDisabled: false,
  }
  handlePickupDateSubmit = () => {
    const { hashId, setPickupDate, newPickupDate } = this.props;
    setPickupDate({ hashId, pickUpDate: newPickupDate });
    this.setState({ isSendFormDisabled: typeof newPickupDate === 'string' });
  };

  handleSetTransferredForTransportSubmit = (description) => {
    const { hashId, setTransferredForTransport } = this.props;
    setTransferredForTransport({ hashId, description });
  };

  render() {
    const {
      leftSideClassNames,
      handlePickupDateChange,
      pickupDateLabel,
      datepickerPlaceholder,
      isLoadingTransferredForTransportLoading,
      isLoadingPickedUpDate,
      isLoadingPickupDate,
      isPickedupCheckboxChecked,
      pickedupSubmitLabel,
      pickedupCheckboxLabel,
      handleSetPickedUpDateSubmit,
      status,
      sendLabel,
      cancelLabel,
      t,
    } = this.props;

    const isStatusSentForTransport = status === 'sent_for_transport';
    const transferredForTransportLabel = (
      <span>
        {icons('delivery')}
        {isStatusSentForTransport
          ? t('transferred_for_transport')
          : t('transfer_for_transport')}
      </span>
    );

    const pickupDateSubmitLabel = (
      <span>
        {icons('arrow_right')}
        {t('send_date_to_seller')}
      </span>
    );


    return (
      <PickupDateBar
        className={leftSideClassNames}
        handlePickupDateChange={handlePickupDateChange}
        pickupDateLabel={pickupDateLabel}
        datepickerPlaceholder={datepickerPlaceholder}
        handlePickupDateSubmit={this.handlePickupDateSubmit}
        handleSetTransferredForTransportSubmit={this.handleSetTransferredForTransportSubmit}
        isPickupDateSubmitDisabled={false}
        isEasyTransportOn
        isLoadingTransferredForTransportLoading={isLoadingTransferredForTransportLoading}
        isLoadingPickedUpDate={isLoadingPickedUpDate}
        isLoadingPickupDate={isLoadingPickupDate}
        transferredForTransportLabel={transferredForTransportLabel}
        pickupDateSubmitLabel={pickupDateSubmitLabel}
        isPickedUpSubmitDisabled={this.state.isSendFormDisabled}
        isPickedupCheckboxChecked={isPickedupCheckboxChecked}
        pickedupSubmitLabel={pickedupSubmitLabel}
        pickedupCheckboxLabel={pickedupCheckboxLabel}
        handlePickedupSubmit={handleSetPickedUpDateSubmit}
        isStatusSentForTransport={isStatusSentForTransport}
        sendDateToSellerLabel={t('transfer_for_transport')}
        sendLabel={sendLabel}
        cancelLabel={cancelLabel}
      />
    );
  }
}

PickupDateBarContainerEasyTransport.propTypes = {
  newPickupDate: PropTypes.string,
  leftSideClassNames: PropTypes.string.isRequired,
  handlePickupDateChange: PropTypes.func.isRequired,
  pickupDateLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  datepickerPlaceholder: PropTypes.string.isRequired,
  isLoadingTransferredForTransportLoading: PropTypes.bool.isRequired,
  isLoadingPickedUpDate: PropTypes.bool.isRequired,
  isPickedupCheckboxChecked: PropTypes.bool.isRequired,
  pickedupSubmitLabel: PropTypes.object.isRequired,
  isLoadingPickupDate: PropTypes.bool.isRequired,
  pickedupCheckboxLabel: PropTypes.string.isRequired,
  handleSetPickedUpDateSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  setPickupDate: PropTypes.func.isRequired,
  hashId: PropTypes.string.isRequired,
  setTransferredForTransport: PropTypes.func.isRequired,
  sendLabel: PropTypes.string.isRequired,
  cancelLabel: PropTypes.string.isRequired,
};

PickupDateBarContainerEasyTransport.defaultProps = {
  newPickupDate: '',
};

const mapStateToProps = (state) => {
  return {
    isLoadingTransferredForTransportLoading: get(state, ['offerDetails', 'isLoadingTransferredForTransport']),
    isLoadingPickedUpDate: get(state, ['offerDetails', 'isLoadingPickedUpDate']),
    isLoadingPickupDate: get(state, ['offerDetails', 'isLoadingPickupDate']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setTransferredForTransport: payload => dispatch(SET_TRANSFERRED_FOR_TRANSPORT(payload)),
    setPickupDate: payload => dispatch(SET_PICKUP_DATE(payload)),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withScopedTranslations('details_date_bar')
  )(PickupDateBarContainerEasyTransport)

